/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Cv_File_RequiredInputs */

const en_validation_cv_file_required = /** @type {(inputs: Validation_Cv_File_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please upload your resume as a PDF.`)
};

const de_validation_cv_file_required = /** @type {(inputs: Validation_Cv_File_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte laden Sie Ihren Lebenslauf als PDF hoch.`)
};

/**
* | output |
* | --- |
* | "Please upload your resume as a PDF." |
*
* @param {Validation_Cv_File_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_cv_file_required = /** @type {((inputs?: Validation_Cv_File_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Cv_File_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_cv_file_required(inputs)
	return en_validation_cv_file_required(inputs)
});